
export const ConvertCropNameToTableIdPrefix = (cropName) => {
    return cropName.toLowerCase().replace(/[^a-z0-9]/g, '_');
}
